<template>
<form @submit.prevent="submit" autocomplete="off">
    <ui-alert type="error" v-for="e, index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>
    <fieldset>
        <legend>Adresat</legend>

        <ui-textbox label="Adres e-mail adresata" name="send_to" type="text" v-model="send_to" validation-rules="required|email" :validation-messages="errorMessages" placeholder="Wpisz e-mail adresata wiadomości"></ui-textbox>

    </fieldset>

    <div class="form-actions">
        <ui-button color="primary" :disabled="!send_to">Wyślij testową wiadomość</ui-button>
    </div>
</form>

</template>
<script>
import Utils from './../../services/Utils'
import Messages from './../../services/Messages'

import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'
import FormErrors from './../../mixins/FormErrors'

export default {
  mixins: [Loading, Notify, FormErrors],
  props: ['item'],
  data () {
    return {
      errors: [],
      send_to: '',
      errorMessages: Utils.errorMessages(['required', 'min', 'numeric', 'email'])
    }
  },
  mounted () {

  },
  methods: {

    error (err) {
      this.errors = this.getResponseErrors(err)
      this.notify('Wystąpiły błędy przy wysłaniu wiadomości, sprawdź dane do konta smtp')
    },
    success () {
      this.notify('Wysłano poprawnie tą wiadomość na podany adres e-mail')
    },
    submit () {
      this.errors = []
      window.scrollTo(0, 0)
      const data = {
        send_to: this.send_to
      }
      Messages.test(this.item.id, data).then(this.success, this.error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TestForm.vue?ccab7f8a